import { FC } from 'react';

import type { ButtonModel } from '../../../types';
import BoxButton from '../Box';

const StickyBottomButton: FC<React.PropsWithChildren<React.PropsWithChildren<Omit<ButtonModel, 'size' | 'icon' | 'color'>>>> = (props) => {
  return <BoxButton forStickyBottom {...props} />;
};

export default StickyBottomButton;
